/**
 * Convert Tiptap Mention spans to mustache placeholders.
 * Example: <span data-type="mention" data-id="shop.name">@Shop Name</span>
 *   -> {{shop.name}}
 */
export function formatTemplate(html: string): string {
	if (!html) return html;
	const mentionSpanRegex =
		/<span\b[^>]*data-type=["']mention["'][^>]*data-id=["']([^"']+)["'][^>]*>.*?<\/span>/g;
	return html.replace(mentionSpanRegex, (_, id: string) => `{{${id}}}`);
}

export default formatTemplate;
